import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button } from 'edozvola-frontend-lib/dist/ui/components';
import SpecialBuildingPartTable from 'app/edozvola/cases/special-building-part/special-building-part-table';
import SpecialBuildingPartForm from 'app/edozvola/cases/special-building-part/special-building-part-form';
import { getCaseContext } from 'app/shared/util/context-util';
import { fetchCaseBuildingOptionsQuery } from 'app/edozvola/cases/special-building-part/service/special-building-part.queries';

const SpecialBuildingPart = () => {
  const { id: uuid } = useParams<{ id: string }>();
  const [specialBuildingPartId, setSpecialBuildingPartId] = useState<string | null>(null);
  const [readOnly, setReadOnly] = useState(false);
  const { sidebarItemPair } = getCaseContext();

  const { data: buildingOptions } = fetchCaseBuildingOptionsQuery(uuid);

  const caseHasBuildings = (buildingOptions ?? []).length > 0;

  const openSpecialBuildingPartForm = () => {
    setSpecialBuildingPartId('');
    setReadOnly(false);
  };

  return (
    <>
      <h6 className={'form-header'}>Posebni dijelovi zgrade</h6>
      {!sidebarItemPair?.readOnly && caseHasBuildings && (
        <div className={'d-flex justify-content-end pb-4 gap-2'}>
          <Button label={'Dodaj posebni dio zgrade'} color={'info'} prependIcon={'plus'} size={'lg'} onClick={openSpecialBuildingPartForm} />
        </div>
      )}

      <SpecialBuildingPartTable setSpecialBuildingPart={setSpecialBuildingPartId} setReadOnly={setReadOnly} />
      {specialBuildingPartId !== null && (
        <SpecialBuildingPartForm
          specialBuildingPartId={specialBuildingPartId}
          setSpecialBuildingPartId={setSpecialBuildingPartId}
          readOnly={readOnly}
        />
      )}
    </>
  );
};

export default SpecialBuildingPart;
